import React from "react";
import { AppBar, Toolbar, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 2 }}>
          Telegram Poster Bot
        </Typography>
        <Button color="inherit" component={Link} to="/">Dashboard</Button>
        <Button color="inherit" component={Link} to="/telegram-accounts">Telegram Accounts</Button>
        {/* <Button color="inherit" component={Link} to="/proxy-management">Proxy Management</Button> */}
        <Button color="inherit" component={Link} to="/message-creation">Message Creation</Button>
        <Button color="inherit" component={Link} to="/task-scheduler">Task Scheduler</Button>
        <Button color="inherit" component={Link} to="/archive-filtering">Archive & Filtering</Button>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;